module.exports = __webpack_public_path__ + "fonts/SpaceGrotesk-Regular.d6feaf8.otf";